var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleShadow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 113,
    viewBox: "0 0 119 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.767 9.41079C119.345 -21.5431 -26.6123 35.3593 4.82744 35.2526C87.7998 34.9711 36.706 70.9164 44.9054 80.8445L44.9127 80.8616C44.9031 80.8455 44.8929 80.8281 44.9189 80.876C44.9194 80.8756 44.92 80.8751 44.9206 80.8747C85.5835 48.9408 95.868 110.125 110.155 112.056C128.014 114.47 112.39 76.6613 101.243 61.0937C90.095 45.5261 103.232 25.6068 108.767 9.41079Z",
    fill: "url(#paint0_linear_619_1749)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_619_1749",
    x1: 19.5127,
    y1: 6.8812,
    x2: 129.816,
    y2: 110.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7750BF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleShadow);
export default __webpack_public_path__ + "static/media/PurpleShadow.71e235f6b56d9d9de5c7cf4664a37b8c.svg";
export { ForwardRef as ReactComponent };